import React, {useEffect, useRef} from 'react';
import { Modal, Box, Typography, IconButton, Grid, Divider, Button, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const labelStyle = {
  fontWeight: 600,
  color: '#052659',
  fontSize: '0.95rem',
};

const valueStyle = {
  color: '#333',
  fontSize: '0.9rem',
};

const Info = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={6}>
    <Typography sx={labelStyle} gutterBottom>{label}</Typography>
    <Typography sx={valueStyle} paragraph>{value || 'N/A'}</Typography>
  </Grid>
);

// Modal Component
const OpportunityModal = ({ open, onClose, projects }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (open && modalRef.current) {
      modalRef.current.focus();
    }
  }, [open]);

  if (!projects) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top : '50%',
          left : '50%',
          transform: 'translate(-50%, -50%)',
          width : '92%',
          maxWidth : 900,
          maxHeight : '92vh',
          bgcolor: '#fdfdfd',
          boxShadow: 6,
          borderRadius: 3,
          p: 4,
          overflowY: 'auto',
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top : 16,
            right : 16,
            bgcolor: '#f5f5f5',
            '&:hover': { bgcolor: '#e0e0e0' },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography
          variant="body"
          fontWeight={400}
          color="#043885"
          gutterBottom
          sx={{
            borderBottom : '2px solid #043885',
            display: 'inline-block',
            pb: 0.5,
            mb: 3,
            fontSize:"1.4rem",
            paddingRight :"20px"
          }}
        >
          {projects.projectTitle}
        </Typography>

        {/* Project Info */}
        <Grid container spacing={3}>
          <Info label="Company Name" value={projects.companyName} />
          <Info label="Project Summary" value={projects.projectSummary} />
          <Info label="Expected Deliverables" value={projects.expectedDeliverables} />
          <Info label="Tech Stack" value={projects.preferredTechStack} />
          <Info label="Languages" value={projects.preferredProgrammingLanguages} />
          <Info label="Duration" value={projects.projectDuration} />
          <Info label="Time Commitment" value={projects.weeklyTimeCommitment} />
          <Info label="Industry" value={projects.domain} />
          <Info label="Mode of Work" value={projects.modeOfWork} />
          <Info label="Start Date" value={projects.desiredStartDate} />
          <Info label="Deadline" value={projects.applicationDeadline} />
          <Info label="Compensation" value={projects.compensation} />
          <Info label="IP Clauses" value={projects.confidentialityOrIPClauses} />
          {/* <Info label="Created At" value={new Date(projects.createdAt).toLocaleString()} />
          <Info label="Updated At" value={new Date(projects.updatedAt).toLocaleString()} /> */}
        </Grid>

        {/* Divider and Action Buttons */}
        <Divider sx={{ my: 3 }} />

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={onClose} variant="outlined" color="primary">
            Close
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default OpportunityModal;
